<template>
  <Header />
  <div
      class="content"
      v-if="isNotFound"
    >
      <NotFound />
    </div>
  <div v-else>
    <div class="top-visual">
        <div class="frame_img" id="myImg" :style="{backgroundImage: `url(${detailGroupArea?.file ? detailGroupArea?.file : trademarkLogo})`}">
          
          <div class="img-content">
            <h1 style="display: -webkit-box; min-height: -moz-fit-content; min-height: fit-content; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; max-height: 4.5em; width: 100%; word-break: break-word; position: relative; padding: 0 10px; margin: 0px">
                <span id="areaText"></span>
            </h1>
            <div class="img-sub-content for-pc text-[12px]" v-if="selectedAreaSummary">
                <span>
                    タイムシェアリングが運営する少人数から大人数まで利用可能な、格安・オシャレな貸し会議室・レンタルスペースを掲載しています。
                </span>
            </div>
            <div class="img-sub-content for-sp text-[12px]" v-if="selectedAreaSummary">
                <span>
                    タイムシェアリングが運営する少人数から大人数まで利用可能な、格安・オシャレな貸し会議室・レンタルスペースを掲載しています。
                </span>
            </div>
            <div class="img-sub-content-new">
              ★おすすめ用途★
              <span v-if="selectedAreaPurposeOfUses">{{ selectedAreaPurposeOfUses }}</span>
            </div>
          </div>
        </div>
      </div>
    <div id="js-search-sticky" class="search-bar js-search-bar-sticky">
      <SearchBarArea :researchValue="researchValue" @emitSort="emitSort" :totalSpace="TotalSpace" :selectedAreaSummary="selectedAreaSummary" :isHomePage="true"/>
    </div>
    <div class="content-page">
      <!-- <div class="lg:mb-[20px] mt-[20px] flex justify-center" v-if="!isLoading">
        <h2 class="text-[22px] font-bold text-center lg:text-2xl">{{ detailGroupArea?.name || 'おすすめ'}}の貸し会議室・レンタルスペース・イベント会場を一覧から探す</h2>
      </div> -->
      <div class="list_space">
        <SearchSpaces :isArea="true" :researchValue="researchValue" v-if="researchValue" :isSort="isSort" :valueSort="valueSort" :titleName="selectedAreaSummary || 'おすすめ'"
          @emitTotalSpace="emitTotalSpace" @emitSort="emitSort" @isFirstLoadingDone="setLoadingFirst" />
      </div>

       <div class="c-features_list"
        v-if="listFeatures && listFeatures?.length && route.query?.ar">
        <div v-for="(listFeature, key) in listFeatures" :key="listFeature">
          <div class="content_space">
            <div class="content-title">
              <h2>{{ listFeature?.heading }}</h2>
              <span style="color: #000; font-size: 18px; font-weight: 400; line-height: normal;">{{ !key ? 'Characteristics' : 'Access' }}</span>
            </div>
            <div v-for="content in listFeature?.contents" :key="content" class="one-content">
              <span class="content-image-pc">
                <img 
                  :src="!key ? areaFeatureCharacteristicsLogo : areaFeatureAccessLogo"
                  :alt="!key ? `特徴` : `アクセス`"
                  style="width: 54px; height: 54px;"
                />
              </span>
              <div class="content-text">
                <h3>
                  {{ content?.title }}
                </h3>
                <hr class="gradation-line" />
                <p style="white-space: pre-wrap;" v-html="content?.description"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="queryCategory == '' && queryGroupArea != ''">
        <GroupAreaRecommendSpaces :researchValue="researchValue" :nameGroupArea="detailGroupArea?.name" />
      </div>

      <AreaList v-if="store.listGroupArea?.length" :listLocation="listGroupArea"
        :researchValue="researchValue" />

      <CategoriesList v-if="store.getListCategory?.length" :listCategory="store.getListCategory"
        :researchValue="researchValue" />

      <div class="img-content" v-if="!isLoading">
        <div class="img-sub-content for-pc text-[12px]" v-if="selectedAreaSummary">
          <span>
            {{ selectedAreaSummary }} でおすすめの貸し会議室・レンタルスペース・イベント会場の一覧です。
          </span>
        </div>
        <div class="img-sub-content for-sp text-[12px]" v-if="selectedAreaSummary">
          <span>
            {{ selectedAreaSummary }} でおすすめの貸し会議室・レンタルスペース・イベント会場の一覧です。
          </span>
        </div>
      </div>
    </div>
  </div>

  <Footer />
  <ContactInfo />
</template>

<script setup>
/* eslint-disable */
import { ref, onMounted, onUnmounted, defineAsyncComponent, watch, computed } from "vue";
import Header from "@/client/organisms/LayoutHome/Header/Header.vue";
import Footer from "@/client/organisms/LayoutHome/Footer/Footer.vue";
import ContactInfo from "@/client/organisms/LayoutHome/ContactInfo/ContactInfo.vue";
import areaFeatureCharacteristicsLogo from "@/client/assets/images/area_feature_logo.svg";
import areaFeatureAccessLogo from "@/client/assets/images/area_access_logo.svg";
import question from "@/client/assets/images/q.png";
import answer from "@/client/assets/images/a.png";
import { useRoute } from "vue-router";
import {
  getListGroupAreaFaqApi,
  getListLocationApi,
  getListGroupAreaFeaturesApi,
  getListGroupAreaStatisticsApi,
  getListGroupAreaApi
} from "@/client/api";
import useCustomer from "@/client/store/Customer";
import SearchBarArea from "@/client/components/SearchBarArea/SearchBarArea.vue";
import SearchSpaces from "@/client/components/Space/SearchSpaces.vue";
import trademarkLogo from "@/client/assets/images/locationKanto.jpg";
import LoadingScreen from "@/admin/components/Loading/LoadingScreen.vue";
import Lodash from 'lodash';
import useStore from "@/client/store/Customer";
import { FAQ_TYPE } from '@/client/const'
import { reactive } from "vue";
import NotFound from "@/client/components/NotFound/NotFound.vue";

const AreaList = defineAsyncComponent({
  loader: () => import('@/client/components/Areas/AreaList.vue'),
  loadingComponent: LoadingScreen,
  delay: 10000,
  timeout: 3000
})

const GroupAreaRecommendSpaces = defineAsyncComponent({
  loader: () => import('@/client/components/Space/GroupAreaRecommendSpaces.vue'),
  loadingComponent: LoadingScreen,
  delay: 10000,
  timeout: 3000
})

const ReasonList = defineAsyncComponent({
  loader: () => import('@/client/components/Reasons/ReasonList.vue'),
  loadingComponent: LoadingScreen,
  delay: 10000,
  timeout: 3000
})

const CategoriesList = defineAsyncComponent({
  loader: () => import('@/client/components/Categories/CategoriesList.vue'),
  loadingComponent: LoadingScreen,
  delay: 10000,
  timeout: 3000
})

const store = useStore();
const route = useRoute();
const statistics = ref([]);
const groupAreaId = ref("");
const groupArea = ref({});
const detailGroupArea = ref({});
const storeCustomer = useCustomer();
const listGroupArea = ref([]);
const category = ref();
const listFaq = ref();
const listFeatures = ref();
const categorySlug = route.params.categorySlug;
const isSort = ref(false);
const valueSort = ref();
const queryCategory = ref(route.query?.ctg ?? '');
const queryGroupArea = ref(route.query?.ga ?? '');
const TotalSpace = ref(0)
const nameCategory = ref();
const isLoading = ref(false);
const isLoadingListSpace = ref(true);
const isNotFound = ref(false);
const selectedAreaSummary = ref("");
const selectedAreaPurposeOfUses = ref("");

const listPeopleFormTo = [
  { id: "1-5", data: { from: 1, to: 5 } },
  { id: "6-20", data: { from: 6, to: 20 } },
  { id: "21-40", data: { from: 21, to: 40 } },
  { id: "41-60", data: { from: 41, to: 60 } },
  { id: "61-100", data: { from: 61, to: 100 } },
  { id: "101-", data: { case_person: 101 } },
];

const listPeople = reactive([
  { name: "ブース(個室)", id: "1-5" },
  { name: "〜20人", id: "6-20" },
  { name: "21〜40人", id: "21-40" },
  { name: "41〜60人", id: "41-60" },
  { name: "61〜100人", id: "61-100" },
  { name: "100人〜", id: "101-" },
]);

const getSearchPeople = () => {
  if (route.query.pp) {
    const result = listPeopleFormTo.filter((item) => {
      return route.query.pp == item.id;
    });
    if (result.length) {
      return result[0].data;
    }
  }
  return {};
};

const researchValue = ref({
  ga: route.query?.ga ?? "",
  lp: route.query.lp ? route.query.lp : "",
  ctg: route.query.ctg ? route.query.ctg : "",
  pp: route.query.pp ? route.query.pp : "",
  dt: route.query.dt ? route.query.dt : "",
  ss: route.query.ss ? route.query.ss : "",
  ar: route.query.ar ? route.query.ar : "", 
  gp: route.query.gp ? route.query.gp : "", 
});

watch([researchValue.value, store], async () => {
    const areaList = store.areaList;
    const selectedAreaIds = route.query.ar?.split(',') || [];
    const matchedAreas = areaList?.filter(area => selectedAreaIds.includes(String(area.id)));
    const orderedAreas = selectedAreaIds
        .map(id => matchedAreas?.find(area => String(area.id) === id))
        .filter(area => area); 
    selectedAreaSummary.value = orderedAreas?.map(area => area.name).join('・');

    const listGroupAreaData = store.listGroupArea;
    const matchedGroupData = Array.isArray(listGroupAreaData) ? listGroupAreaData?.filter(group => {
        const children = Array.isArray(group.child) ? group.child : Object.values(group.child || {});
        return children.some(child => selectedAreaIds.includes(String(child.id)));
    }) : [];
    const namePurposeOfUsesList = matchedGroupData?.map(group => group.name_purpose_of_uses);
    const uniqueJoined = [...new Set(
            namePurposeOfUsesList.flatMap(item => item.split('・'))
        )].join('・');
    selectedAreaPurposeOfUses.value = uniqueJoined;
  
  const researchVal = researchValue.value;
  let searchTitle = "";
  if (researchVal.ga) {
    const listLocation = Array.from(store.getListGroupArea);
    const currentAreaName = listLocation.find(loc => loc.id && loc.id == researchVal.ga)?.name ?? '';
    searchTitle = `${currentAreaName}の貸し会議室・レンタルスペース・イベント会場｜【公式】タイムシェアリング`
  } else if (researchVal.ctg) {
    const listCategory = Array.from(store.getListCategory);
    // const categoryIds = researchVal.category.split(',').map(id => Number(id));
    const categoryIds = typeof researchVal.ctg === 'string'? researchVal.ctg.split(',').map(id => Number(id)): Array.isArray(researchVal.ctg) ? researchVal.ctg.map(id => Number(id)) : [];
    const flatCategories = listCategory.flatMap(cat =>  cat.children && Array.isArray(cat.children) ? [cat, ...cat.children]: [cat]);
    const currentCategoryName = flatCategories
    .filter(cate => categoryIds.includes(cate.id))
    .map(cate => {
      const parent = listCategory.find(p => p.id === cate.id);
      const isParent = !!parent;
      const isChild = listCategory.some(p => p.children?.some(c => c.id === cate.id));
      return isParent ? `${cate.name}すべて` : cate.name;
    })
    .join('・');
    searchTitle = `${currentCategoryName}の貸し会議室・レンタルスペース・イベント会場｜【公式】タイムシェアリング`
  } else if (researchVal.pp) {
    const currentPeopleName = listPeople.find(ppl => ppl.id && ppl.id == researchVal.pp)?.name ?? '';
    searchTitle = `${currentPeopleName}の貸し会議室・レンタルスペース・イベント会場｜【公式】タイムシェアリング`
  } else if (researchVal.dt) {
    const fullDateTime = researchVal.dt;
    searchTitle = `${fullDateTime}に使える貸し会議室・レンタルスペース・イベント会場｜【公式】タイムシェアリング`
  } else {
    searchTitle = `貸し会議室・レンタルスペース・イベント会場｜【公式】タイムシェアリング`
  }
  document.title = searchTitle;
});

const truncateAreaList = async () => {
    var container = document.getElementById("areaText");
    
    let displayText = "";
    const suffix = "の貸し会議室・レンタルスペース・イベント会場";
    if(container) {
    
        let areaList = selectedAreaSummary.value.split('・');
        for (let i = 0; i < areaList.length; i++) {
            const tempText = displayText + areaList[i] + "・";
            container.innerText = tempText + suffix + '... ';

            if (container.parentElement.scrollHeight > container.parentElement.clientHeight) {
                displayText = (displayText.endsWith("・") ? displayText.slice(0, -1) : displayText) + '... '
                break;
            }
    
            displayText = tempText;
        }
    } 
    displayText = displayText.endsWith("・") ? displayText.slice(0, -1) : displayText;
    if(displayText == '') {
        displayText = 'おすすめ'
    }
    container.innerText = displayText + suffix
}

window.addEventListener("load", truncateAreaList);
window.addEventListener("resize", truncateAreaList);

watch(route,
   async () => {
    if(route.query?.ar){
        await getListGroupAreaFeatures(queryGroupArea.value);
        const areaList = store.areaList;
        const selectedAreaIds = route.query.ar?.split(',') || [];
        const matchedAreas = areaList?.filter(area => selectedAreaIds.includes(String(area.id)));
        const orderedAreas = selectedAreaIds
            .map(id => matchedAreas?.find(area => String(area.id) === id))
            .filter(area => area); 
        selectedAreaSummary.value = orderedAreas?.map(area => area.name).join('・');
        
        const listGroupAreaData = store.listGroupArea;
        const matchedGroupData = Array.isArray(listGroupAreaData) ? listGroupAreaData?.filter(group => {
            const children = Array.isArray(group.child)
                ? group.child
                : Object.values(group.child || {});
        
            return children.some(child => selectedAreaIds.includes(String(child.id)));
        }) : [];
        const namePurposeOfUsesList = matchedGroupData?.map(group => group.name_purpose_of_uses);
        const uniqueJoined = [...new Set(
                namePurposeOfUsesList.flatMap(item => item.split('・'))
            )].join('・');
        selectedAreaPurposeOfUses.value = uniqueJoined;
  
    }else{
        listFeatures.value = [];
        selectedAreaPurposeOfUses.value ="";
        selectedAreaSummary.value = "";
    }
    
    if (route.query?.ga) {
      groupArea.value = route.query?.ga
      detailGroupArea.value = store.listGroupArea.find((item) => item.id == groupArea.value)
      isLoading.value = false;
    } else if(!route.query?.ga && route.params.area_slug) {
      detailGroupArea.value = store.listGroupArea.find((item) => item.slug == groupArea.slug)
      groupArea.value = detailGroupArea.value.id
      isLoading.value = false;
    } else {
      detailGroupArea.value = {}
      isLoading.value = false;
    }
    if (route.query) {
      queryCategory.value = route.query?.ctg ?? ''
      groupArea.value = route.query?.ga
      queryGroupArea.value = route.query?.ga ?? ''
      if (queryGroupArea.value != '') {
        getListGroupAreaStatistics(queryGroupArea.value)
        getListGroupAreaFaq(queryGroupArea.value);
        getListGroupAreaFeatures(queryGroupArea.value);

      }
      if (queryCategory.value) {
        const arrCategory = store.listCategory
        if (Array.isArray(arrCategory)) {
            const ids = queryCategory.value.split(',').map(id => id.trim());
            const matchedNames = [];

            arrCategory.forEach(parent => {
            // Check if parent matches
            if (ids.includes(String(parent.id))) {
                matchedNames.push(`${parent.name}すべて`);
            }
            if (Array.isArray(parent.children)) {
                parent.children.forEach(child => {
                if (ids.includes(String(child.id))) {
                    matchedNames.push(child.name);
                }
                });
            }
            });
            nameCategory.value = matchedNames.length > 0 ? matchedNames.join('・') : '';
        }
      }
    }
    if (route) {
    //   getSearchPeople()
    //   researchValue.value.people_count = getSearchPeople()
      researchValue.value.ss = route.query?.ss ?? ''
    }

    truncateAreaList();
  },
  { deep: true }
)


onMounted(async () => {
  isLoading.value = true;
  const res = await getListGroupAreaApi();
  const listGroupAreaData = res.data

  const allArea = await getListLocationApi();
  const areaList = allArea.data;
  store.areaList = areaList;
  const selectedAreaIds = route.query.ar?.split(',') || [];
  const matchedAreas = areaList?.filter(area => selectedAreaIds.includes(String(area.id)));
  const orderedAreas = selectedAreaIds
            .map(id => matchedAreas?.find(area => String(area.id) === id))
            .filter(area => area);
  selectedAreaSummary.value = orderedAreas?.map(area => area.name).join('・');

  listGroupArea.value = listGroupAreaData;
  store.listGroupArea = listGroupAreaData;

  if (listGroupAreaData.length) {
    let foundGroupArea = {};
    if(researchValue.value?.ga || route.params.areaSlug) {
      if(researchValue.value?.ga) {
      foundGroupArea = listGroupAreaData.find(
        (element) => element.id == researchValue.value?.ga
      );
      } else if(!researchValue.value?.ga && route.params.areaSlug) {
        foundGroupArea = listGroupAreaData.find(
          (element) => element.slug == route.params.areaSlug
        );
      }
      if (foundGroupArea && foundGroupArea?.id) {
        isNotFound.value = false;
        researchValue.value.ga = foundGroupArea.id
        groupArea.value = foundGroupArea
        detailGroupArea.value = groupArea.value;

        researchValue.value.ga = groupArea.value.id;
        const statisticsRes = await getListGroupAreaStatistics(groupArea.value?.id);
        if (detailGroupArea.value?.statistics) {
          detailGroupArea.value.statistics = statisticsRes;
        }
        if (detailGroupArea.value?.file) {
          detailGroupArea.value.file = `${detailGroupArea.value?.file}`;
        }
        groupAreaId.value = groupArea.value?.id;
      } else {
        isNotFound.value = true;
      }
    }
  }
  const categoryData = store.listCategory;
  if (categoryData.length) {
    category.value = categoryData
      .filter((category) => category.slug == categorySlug)
      .shift();
  }
  if(queryCategory.value){
    const arrCategory = store.listCategory
    if (Array.isArray(arrCategory)) {
        const ids = queryCategory.value.split(',').map(id => id.trim());
        const matchedNames = [];

        arrCategory.forEach(parent => {
        // Check if parent matches
        if (ids.includes(String(parent.id))) {
            matchedNames.push(`${parent.name}すべて`);
        }
        if (Array.isArray(parent.children)) {
            parent.children.forEach(child => {
            if (ids.includes(String(child.id))) {
                matchedNames.push(child.name);
            }
            });
        }
        });
        nameCategory.value = matchedNames.length > 0 ? matchedNames.join('・') : '';
    }
  }
  isLoading.value = false;
  getListGroupAreaFaq(queryGroupArea.value);
  getListGroupAreaFeatures(queryGroupArea.value);
  getListGroupAreaStatistics(queryGroupArea.value)
  createTitleDesc(route);
  truncateAreaList();
  storeCustomer.isLoading = false;
});

function createTitleDesc(routeInstance) {
  if (detailGroupArea.value) {
    const nameSpace = detailGroupArea.value?.name;

    // メタタグのdescription設定処理
    if (routeInstance.meta.description) {
      var setDesc = nameSpace ?? '' + routeInstance.meta.description;
      document
        .querySelector("meta[name='description']")
        .setAttribute("content", setDesc);
    }
  }
}

const getListGroupAreaStatistics = async (groupAreaId) => {
  if (groupAreaId) {
    try {
      const res = await getListGroupAreaStatisticsApi(groupAreaId);
      statistics.value = res.data;
      return res.data;
    } catch (errors) {
      //toast.error("has error");
    } finally {
      storeCustomer.isLoading = false;
    }
  }
};

const getListGroupAreaFaq = async (groupAreaId) => {
  try {
    if (groupAreaId) {
      const faq = await getListGroupAreaFaqApi(groupAreaId);
      listFaq.value = faq.data?.map(item => {
          const flagReplaceAreaName = item.type === FAQ_TYPE.NORMAL ? detailGroupArea.value.area_names : detailGroupArea.value.area_names_sub_faq
          const question = item.question.replace(/\[area names\]/g, flagReplaceAreaName ?? '').replace(/駅駅/g, '駅');
          const answer = item.answer ? item.answer.replace(/\[area names\]/g, flagReplaceAreaName ?? '').replace(/駅駅/g, '駅') : null;
          return {
              question,
              answer,
          }
      });
    }
  } catch (errors) {
  } finally {
  }
};

const getListGroupAreaFeatures = async (groupAreaId) => {
  try {
    if (route?.query?.ar) {
      const features = await getListGroupAreaFeaturesApi(null, {area_id: route?.query?.ar});
      listFeatures.value = features.data;
     }else{
        listFeatures.value = [];
     }
  } catch (errors) {
  } finally {
  }
};

const width = ref(window.innerWidth);
const handleStickyNavSP = () => {
  const heightHeader = document.querySelector('.header').offsetHeight;
  const searchBar = document.getElementsByClassName('js-search-bar-sticky');

  if (width.value < 601) {
    searchBar[0].style.top = heightHeader - 1 + 'px'
  } else {
    searchBar[0].style.top = heightHeader - 1 + 'px'
  }
}

const handleResize = Lodash.debounce(() => {
  width.value = window.innerWidth;
  handleStickyNavSP();
}, 500);

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

onMounted(() => {
  const searchBar = document.getElementsByClassName('search-bar');
  const searchContainer = document.getElementsByClassName('search-bar-container');
  const c_sort = document.getElementsByClassName('c-sort');
  window.addEventListener('scroll', () => {
    if (window.scrollY > 180) {
      if(searchBar[0]) {
        searchBar[0].classList.add('js-sticky');
        searchContainer[0].classList.add('js-sticky-cont');
        handleStickyNavSP();
      }
      if (c_sort[0]) { c_sort[0].style.display = "none"; }
    } else {
      if (searchBar[0]) {
        searchBar[0].classList.remove('js-sticky');
        searchContainer[0].classList.remove('js-sticky-cont');
      }
      if(window.outerWidth > 768) {
          if(c_sort[0]) { c_sort[0].style.display = "flex";}
      } else {
          if(c_sort[0]) { c_sort[0].style.display = "block";}
      }
    }
  });
});

const emitSort = (data, valSort) => {
  isSort.value = data;
  researchValue.value.ss = valSort
};

const emitTotalSpace = (data) => {
  TotalSpace.value = data
};

const setLoadingFirst = () => {
  isLoadingListSpace.value = false;
};

</script>

<style scoped lang="scss">
@import "@/client/views/ListAreaByCategory/ListAreaByCategory.scss";
@import "./Style.scss";

.c-faq_list_title {
  text-align: center;
  margin-bottom: 20px;

  h2 {
    @media (max-width:575px) {
        text-align: left;
    }
    span {
      color: #000;
      font-size: 24px;
      font-weight: 700;
      line-height: normal;
    }
  }

  p {
    color: #000;
    font-size: 18px;
    font-weight: 400;
    line-height: normal;
  }
}

.js-sticky {
  position: sticky;
  background: #fff;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px;
  z-index: 9;

  .search-bar-container {
    padding-left: 5px;
    padding-right: 15px;
    justify-content: space-between;
    gap: 10px;
  }

  .search-form.for-pc {
    border: none;
  }
}

.search-bar {
  position: sticky;
  top: 137px;
  margin-top: -85px;
  width: 100%;
  z-index: 9;

  .sort-container {
    display: none;
  }

  &.js-sticky {
    .sort-container {
      min-width: 275px;
      display: flex;
      width: auto;
    }
  }
}

@media (max-width: 768px) {
  .search-bar {
    margin-top: -42px;
  }

  .c-faq_list,
  .c-features_list,
  .c-list_statistics {
    padding: 0 14px;
  }
}

@media (max-width: 767px) {
  .search-bar {
    &.js-sticky {
      .sort-container {
        display: none;
      }
    }

    .search-bar-container {
      justify-content: center;
      padding-right: 5px;
    }
  }

  .c-faq_list_title {
    h3 {
      span {
        font-size: 22px;
        font-weight: 700;
      }
    }
  }
}

@media (max-width:575px){
    .c-features_list{
        padding: 0px;
    }
    .content_space .content-title{
        padding: 10px 0px;
    }
    .content_space .content-title h2{
        text-align: left;
        display: block !important;
    }
    .content_space .content-text{
        padding: 0px 14px;
    }
    .content_space.c-list_statistics {
        padding: 0px;
    }
    .content_space .one-content.one-content-data .content-statistics{
        width: 100%;
        padding: 5px 14px;
    }
}
</style>
